import {Button, FormControl, Stack, TextField, Typography} from "@mui/material";
import React, {useContext, useEffect, useState} from "react";
import {Link, useNavigate} from 'react-router-dom';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import {config} from "../../../constant";
import UserContext from "../../../UserContext";
import DialogIdentification from "../dialog-identification/DialogIdentification";
import {joinWithLastWord} from '../../../utils/formatString';

export default function VotePage() {
    const navigate = useNavigate();
    const { user, setUser } = useContext(UserContext);
    const [identificationDialogOpen, setIdentificationDialogOpen] = useState(false);
    const [categoriesAndNominations, setCategoriesAndNominations] = useState([]);
    const [votes, setVotes] = useState(null);

    useEffect(() => {
        updateList();
    }, []);

    useEffect(() => {
        if (user) {
            // Changement de user
            initVotes(categoriesAndNominations);
        }
    }, [user]);

    const updateList = () => {
        fetch(`${config.BASE_URL}/nominations/by-categories`)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`${response.status} ${response.statusText}`)
                }
                return response.json();
            }).then(data => {
                setCategoriesAndNominations(data);
                if (!user) {
                    // setIdentificationBeforeVote(true);
                    setIdentificationDialogOpen(true);
                } else {
                    initVotes(data);
                }
            }).catch(error => {
                const message = 'Erreur dans la récupération des nominations';
                console.error(message, error);
                navigate("/error", {state: {message: message}});
            });
    };

    const initVotes = (categoriesAndNominationFromRequest) => {
        fetch(`${config.BASE_URL}/votes/voter/${user.id}`)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`${response.status} ${response.statusText}`)
                }
                return response.json();
            }).then(data => {
                updateVotesFromData(data, categoriesAndNominationFromRequest);
            }).catch((error) => {
                const message = 'Erreur dans la récupération des votes';
                console.error(message, error);
                navigate("/error", {state: {message: message}});
            });
    };

    const updateVotesFromData = (votes, categoriesAndNominationFromRequest) => {
        setVotes(categoriesAndNominationFromRequest.map(categoryAndNominations => {
            // On recherche le vote correspondant à la catégorie
            const vote = votes && votes.length > 0 ? votes.find(current => current.category.id === categoryAndNominations.category.id) : null;
            return {
                id: null,
                reason: vote ? (vote.reason ? vote.reason : '') : '',
                category: {
                    id: categoryAndNominations.category.id,
                    name: categoryAndNominations.category.name
                },
                voter: {
                    id: user.id
                },
                nomination: {
                    id: vote ? vote.nomination.id : null
                }
            }
        }));
    };

    const handleVoteNominationChange = (event) => {
        const {
            target: { name, value }
        } = event;

        const nextVotes = [...votes];
        nextVotes.find(vote => vote.category.id === parseInt(name, 10)).nomination.id = parseInt(value, 10);
        setVotes(nextVotes);
    };

    const handleVoteChange = (event, categoryId) => {
        const {
            target: { name, value }
        } = event;

        const nextVotes = [...votes];
        const voteOfCategory = nextVotes.find(vote => vote.category.id === parseInt(categoryId, 10));
        voteOfCategory[name] = value;
        setVotes(nextVotes);
    };

    const getNominations = (categoryId) => {
        return categoriesAndNominations.find(categoryAndNominations => categoryAndNominations.category.id === categoryId).nominations;
    };

    const handleIdentificationClose = (reason, identifed) => {
        if (reason && reason === "backdropClick") {
            return;
        }
        setIdentificationDialogOpen(false);
        if (!identifed) {
            navigate('/dashboard/home');
        }
    };

    const getNominationDescription = (nomination) => {
        return joinWithLastWord(nomination.nominees.map(nominee => nominee.firstName), ', ', 'et') + ' (' + nomination.reason + ')';
    };

    const saveVotes = () => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(votes)
        };
        fetch(`${config.BASE_URL}/votes`, requestOptions)
            .then(response => {
                console.log(response.status);
                if (!response.ok) {
                    throw new Error(`${response.status} ${response.statusText}`)
                }
                navigate('/dashboard/vote/result');
            }).catch((error) => {
                const message = 'Erreur dans la sauvgarde des votes';
                console.error(message, error);
                navigate("/error", {state: {message: message}});
            });
    };

    return (
        <>
            {votes && (
                <>
                    {votes.filter(vote => getNominations(vote.category.id).length > 0).map(vote => (
                        <Accordion key={vote.category.id}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon/>} aria-controls="panel1a-content" id="panel1a-header" sx={{flexGrow: 1, flexDirection: "row-reverse"}}>
                                <Typography>{vote.category.name}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <FormControl>
                                    <RadioGroup name={vote.category.id.toString()} value={vote.nomination.id} onChange={handleVoteNominationChange}>
                                        {getNominations(vote.category.id).map(nomination => (
                                            <FormControlLabel
                                                key={nomination.id}
                                                value={nomination.id}
                                                control={<Radio />}
                                                label={<Typography sx={{fontSize: '0.875rem'}}>{getNominationDescription(nomination)}</Typography>}
                                                sx={{mb: 2}}
                                            />
                                        ))}
                                    </RadioGroup>
                                    <TextField
                                        margin="dense"
                                        id="reason"
                                        name="reason"
                                        label="Raison"
                                        fullWidth
                                        variant="standard"
                                        value={vote.reason}
                                        onChange={(event) => handleVoteChange(event, vote.category.id)}
                                    />
                                </FormControl>
                            </AccordionDetails>
                        </Accordion>
                    ))}

                    <Stack direction="row" sx={{mt: 3}}>
                        <Button variant="contained" sx={{textTransform: 'none'}} onClick={saveVotes}>
                            Valider
                        </Button>
                        <Link to="/dashboard/vote/result">
                            <Button variant="contained" sx={{ml: 2, textTransform: 'none'}}>
                                Voir les résultats
                            </Button>
                        </Link>
                    </Stack>
                </>
            )}
            {identificationDialogOpen && (
                <DialogIdentification open={identificationDialogOpen} onClose={handleIdentificationClose}>
                </DialogIdentification>
            )}
        </>
    );
}